import { Injectable } from '@angular/core';
import { UserPreferences } from 'src/services/user/User';
import { UserService } from 'src/services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  private readonly defaultPreferences: UserPreferences = {
    currencyCode: 'USD',
    openMobileAddByDefault: true,
  };

  public preferences: UserPreferences = this.defaultPreferences;

  constructor(private userService: UserService) {
    this.userService.user.subscribe((user) => {
      this.preferences = { ...this.preferences, ...user?.preferences };
    });
  }
}
